/* "Goal: Grow my personal account (new) · filled in from the username
   generator" — shown by the form and the chat while AI Studio is on the goal
   prefilled after a sign-up from the name generators (T24). */
import React from 'react';

export default function PrefillPill({ prefill, goalLabel }) {
  return (
    <span data-testid='prefill-pill'
      style={{ fontSize: 12, fontWeight: 600, color: '#4338ca', background: '#eef2ff', border: '1px solid #c7d2fe', borderRadius: 999, padding: '4px 10px' }}>
      Goal: {goalLabel} (new) · filled in from the {prefill.source}
    </span>
  );
}
